import React from 'react';
import { FaFileSignature, FaHome, FaGlobeAmericas, FaUniversity } from 'react-icons/fa';
import notarySeal from '../assets/images/notary-seal.png';
import '../styles/ServicesPage.css';

const Services = () => {
  const services = [
    {
      icon: <FaFileSignature size={40} color="#009ef9" />,
      title: 'General Notarization',
      description: 'Witnessing signatures on affidavits, contracts, and other documents.'
    },
    {
      icon: <FaHome size={40} color="#ee1810" />,
      title: 'Real Estate Documents',
      description: 'Deeds, mortgages, refinancing paperwork, and title transfers.'
    },
    {
      icon: <FaGlobeAmericas size={40} color="#34a839" />,
      title: 'Online Notarization',
      description: 'Secure remote notarization via video conference.'
    },
    {
      icon: <FaUniversity size={40} color="#009ef9" />,
      title: 'Legal Documents',
      description: 'Power of attorney, wills, trusts, and court documents.'
    }
  ];

  return (
    <div className="services-page">
      <div className="services-header">
        <h1>Our Notary Services</h1>
        <img src={notarySeal} alt="Notary Seal" className="seal-image" />
      </div>
      
      <div className="services-grid">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <div className="service-icon">{service.icon}</div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
            <button className="btn-learn-more">Learn More</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;